import { Box } from "@raca2022/uikit";
import styled from "styled-components";

export const Container = styled(Box)`
    width: 100%;
    padding: 100px 80px 100px;
    h1{
        width: 100%;
        text-align: center;
        font-weight: 700;
        font-size: 50px;
        line-height: 110%;
        color: #144456;
        font-family: 'PoppinsBold';
        margin-bottom: 72px;
    }
    @media only screen and (max-width: 1024px) {
        h1{
            font-size: 4vw;
        }
    }
    @media only screen and (max-width: 428px) {
        h1{
            font-size: 20px;
        }
    }
`
export const ContentGroup = styled(Box)`
    width: 100%;
    display: flex;
    justify-content: space-between;
    div{
        width: fit-content;
        max-width: 398px;
        width: 25%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        img{
            margin: auto;
            max-width: 100%;
        }
        h3{
            font-weight: 600;
            font-size: 1.66vw;
            line-height: 110%;
            color: #3D4856;
            font-family: 'PoppinsSemiBold';
            text-align: center;
            margin-top: 40px;
            margin-bottom: 16px;
        }
        p{
            font-weight: 500;
            font-size: 0.9375vw;
            line-height: 110%;
            color: #8094AE;
            font-family: 'PoppinsMedium';
            text-align: center;
        }
    }
    @media only screen and (min-width: 1920px){
        div{
            h3{
                font-size: 32px;
            }
            p{
                font-size: 18px;
            }
        }
    }
    @media only screen and (max-width: 1024px){
        flex-direction: column;
        div{
            width: 100%;
            max-width: 100%;
            justify-content: center;
            margin-bottom: 3.27vw;
            h3{
                font-size: 3.27vw;
            }
            p{
                font-size: 2.8vw;
            }
        }
    }
    @media only screen and (max-width: 428px){
        flex-direction: column;
        div{
            margin-bottom: 18px;
            h3{
                font-size: 18px;
            }
            p{
                font-size: 12px;
            }
        }
    }
`